<template>
  <div class="app-shell">
    <SharewellMarketingHeader v-if="showHeader" />
    <router-view></router-view>
  </div>
</template>

<script>
import { computed, defineComponent, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import SharewellMarketingHeader from './sharewell_marketing_header.vue';

export default defineComponent({
  name: 'App',
  components: { SharewellMarketingHeader },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const isRouterReady = ref(false);
    const headerlessPaths = new Set([
      '/design-system'
    ]);

    router.isReady().finally(() => {
      isRouterReady.value = true;
    });

    const isHeaderlessPath = (path) => {
      if (headerlessPaths.has(path)) return true;
      return path.startsWith('/card/');
    };

    const showHeader = computed(() => {
      const path = isRouterReady.value ? route.path : window.location.pathname;
      if (isHeaderlessPath(path)) return false;
      return !route.meta.hideHeader;
    });

    return {
      showHeader
    };
  }
});
</script>

<style>
html, body {
    width: 100% !important;
    overflow-x: hidden !important;
}

.app-shell {
  min-height: 100vh;
  background:
    radial-gradient(ellipse at 78% 0%, rgba(255, 255, 255, 0.62) 0 12%, transparent 30%),
    linear-gradient(90deg, rgba(54, 43, 37, 0.035) 1px, transparent 1px),
    linear-gradient(180deg, rgba(54, 43, 37, 0.035) 1px, transparent 1px),
    linear-gradient(180deg, #d8eeef 0%, #eef8f5 18%, #fff8f0 48%, #fff8f0 100%);
  background-size: 100% 560px, 44px 44px, 44px 44px, 100% 100%;
  background-repeat: no-repeat, repeat, repeat, no-repeat;
}
</style>
